/**
 * Interface para inputs do componente de modal de profile
 */
interface ModalContentInputs {
  title: string;
  subtitle?: string;
  steps: string[];
  buttonText?: string;
}

/**
 * Interface para configuração de modal de cada item do profile
 */
export interface ItemModalConfigProfileScore {
  linkLabel: string;
  inputs: ModalContentInputs;
}
